require("../sass/style.scss");

require("../fonts/fontello/css/fontello.css");


require("./utils.es6");
require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");
require("./vendor/bootstrap-modal");


(function ($) {
    // Mobile Collapse Toggle
    $('.mobile-menu-toggle').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('is-active');
        $('.mobile-menu-collapse').toggleClass('is-open');
        $('body').toggleClass('no-scroll');
    });

    $('.search-toggle, .drawer-search').on('click', function () {
        console.log('Search clicked');
    });

    // if ($(".page-template-page-comparison").length > 0) {
    //     require("./custom/page-comparison.es6");
    // }

    if ($(".hero-banner").length > 0) {
        require("./template_parts/hero_banner.es6");
    }
    if ($(".bottom-banner").length > 0) {
        require("./template_parts/bottom_banner.es6");
    }
    if ($(".seo-section").length > 0) {
        require("./template_parts/seo_section.es6");
    }
    if ($(".featured-section").length > 0) {
        require("./template_parts/featured_section.es6");
    }

    if ($("#seasonic-login-form").length > 0 || $(".woocommerce-lost-password").length > 0 || $("#seasonic-register-form").length > 0) {
        require("./template_parts/auth.es6");
    }

    if ($('.woocommerce-account').length > 0) {
        require('./template_parts/account.es6');
    }

    if ($('.single-product-custom').length > 0) {
        require('./template_parts/single_product.es6');
    }
})(jQuery);